import {
  customPayment,
  calculatePayment,
  chargebackPayment,
  getAppointmentItemReason,
} from '@/services/financial/financialService'

import Vue from 'vue'

const state = {
  appointmentItemReasons: [],
  chargeBackDialog: false,
  recalculateDialog: false,
  isCreatingSinglePayment: false,
}

const getters = {
  chargeBackDialog: (state) => state.chargeBackDialog,
  recalculateDialog: (state) => state.recalculateDialog,
  appointmentItemReasons: (state) => state.appointmentItemReasons,
  isCreatingSinglePayment: (state) => state.isCreatingSinglePayment,
}

const actions = {
  async createCustomPayment({ commit, dispatch }, payment) {
    commit('setIsCreatingSinglePayment', true)

    try {
      await customPayment(payment)
      dispatch('showSuccessMessage', Vue.i18n.translate('financial.messages.singlePaymentSuccess'))
      commit('closeAllModals')
      dispatch('fetchAppointmentAsAdmin', payment.appointment_id)
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    } finally {
      commit('setIsCreatingSinglePayment', false)
    }
  },

  async chargebackPayment({ commit, dispatch }, chargeback) {
    try {
      await chargebackPayment(chargeback)
      dispatch('showSuccessMessage', Vue.i18n.translate('financial.messages.chargeBackSuccess'))
      dispatch('fetchAppointmentAsAdmin', chargeback.appointment_id)
      commit('closeAllModals')
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    }
  },

  async listAppointmentItemReason({ commit, dispatch }) {
    try {
      const { data } = await getAppointmentItemReason()
      commit('setAppointmentItemReasons', data)
      commit('closeAllModals')
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    }
  },

  async createCalculatedPayment({ commit, dispatch }, calculatedPayment) {
    try {
      await calculatePayment(calculatedPayment)
      dispatch('showSuccessMessage', 'Pagamento calculado criado com sucesso!')
      dispatch('fetchAppointmentAsAdmin', calculatedPayment.appointment_id)
      commit('closeAllModals')
    } catch ({ data }) {
      data?.errors && data?.errors?.length >= 1
        ? dispatch('showErrorMessage', data.errors[0].message)
        : dispatch('showErrorMessage', data.message)
    }
  },
}

const mutations = {
  setChargeBackDialogStatus: (state, status) => {
    state.chargeBackDialog = status
  },

  setAppointmentItemReasons: (state, appointmentItemReasons) => {
    state.appointmentItemReasons = appointmentItemReasons
  },

  setIsCreatingSinglePayment: (state, status) => {
    state.isCreatingSinglePayment = status
  }
}

export default {
  state,
  getters,
  actions,
  mutations,
}
